import { PayloadAction } from '@reduxjs/toolkit';
import { DTO__generation } from '@shared/dto/generation/DTO__generation';
import { DTO__user_task } from '@shared/dto/user_task/DTO__user_task';
import { ENUM__redux_action } from '../../../_base/ENUM__redux_action';
import { STATE__generation } from '../../STATE__generation';

export const local_user_task_delete = (payload: string[]): PayloadAction<string[]> => ({
  type: ENUM__redux_action.USER_TASK_DELETE,
  payload,
});

export const init_local_user_task_delete = (state: STATE__generation, action: PayloadAction<string[]>) => {
  if (action.payload.is_empty()) return;

  for (let id of action.payload) {
    state.user_tasks_map.delete(id);

    for (let generarion of state.generations_map.values()) {
      if (generarion.user_task_id != id) continue;

      state.generations_map.delete(generarion._id);
    }

    if (state.user_task_current._id == id) state.user_task_current = DTO__user_task.CREATE_STUB();

    if (state.generation_current.user_task_id == id) state.generation_current = DTO__generation.CREATE_STUB();
  }

  //need refresh user_tasks_map to rerender components
  state.generations_map = new Map(state.generations_map);
  state.user_tasks_map = new Map(state.user_tasks_map);
};
